import {
  AnnouncementService,
  AuthService,
  IAuthService,
  UserService,
  VerificationService,
  CompanyService,
  FeatureService,
  ShareClassService,
  PaymentService,
  AddressService,
  FundraiseService,
  DistributionService,
  SuspendedAmountService,
  RedemptionService,
  SubscriptionService,
  ApprovalService,
  WalletService,
  CertificateService,
  SessionService,
  TaxRulesService,
} from "@redbelly-tokeniser/mystake-api-sdk";

// Use stub mode only if explicitly enabled via environment variable
// In Vite, use import.meta.env for env vars (or process.env if defined in vite.config.ts)
const useStub = import.meta.env.VITE_USE_STUB === "true" || process.env.USE_STUB === "true" || false;

export const announcementService = AnnouncementService.create(useStub);
export const authService: IAuthService = AuthService.create(useStub);
export const userService = UserService.create(useStub);
export const verificationService = VerificationService.create(useStub);
export const companyService = CompanyService.create(useStub);
export const featureService = FeatureService.create(useStub);
export const shareClassService = ShareClassService.create(useStub);
export const paymentService = PaymentService.create(useStub);
export const addressService = AddressService.create(useStub);
export const fundraiseService = FundraiseService.create();
export const distributionService = DistributionService.create(useStub);
export const suspendedAmountService = SuspendedAmountService.create(useStub);
export const redemptionService = RedemptionService.create(useStub);
export const subscriptionService = SubscriptionService.create(useStub);
export const approvalService = ApprovalService.create(useStub);
export const walletService = WalletService.create();
export const certificateService = CertificateService.create();
export const sessionService = SessionService.create();
export const taxRulesService = TaxRulesService.create(useStub);
